import React from "react";
import VenuesPanel from "@/pages/admin/VenuesPanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function TableModule() {
  return (
    <LegacyHost
      title="Table"
      migratedFrom="Editorial desk · Venues catalogue"
      testid="os-modules-table"
    >
      <VenuesPanel />
    </LegacyHost>
  );
}
